import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './Button';
import { motion } from 'framer-motion';
export function CtaBanner() {
  const navigate = useNavigate();
  return <section className="bg-navy py-16" id="quote" data-id="element-14">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-navy-light rounded-2xl p-8 md:p-12 text-center shadow-xl border border-navy-light/50" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-17">
            Ready to Move?
          </h2>
          <p className="text-gray-300 text-lg mb-8 max-w-2xl mx-auto" data-id="element-18">
            Contact us today for a free, no-obligation quote. Let us make your
            next move your best move.
          </p>

          <div className="flex justify-center" data-id="element-19">
            <Button variant="primary" className="w-full sm:w-auto text-lg px-8 py-4" onClick={() => navigate('/quote')} data-id="element-20">
              Get Your Free Quote Today
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}